import { BULK_UPLOADS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(BULK_UPLOADS_ENDPOINT);
export default instance;
